import { ImageIcon } from "lucide-react";

export function StatImageCard({
  image,
  alt,
  stat,
  body,
  source,
  imagePosition,
  placeholder = false,
}: {
  image?: string;
  alt?: string;
  stat: string;
  body: string;
  source?: string;
  imagePosition?: string;
  placeholder?: boolean;
}) {
  return (
    <figure className="overflow-hidden rounded-2xl border border-border/60 bg-background p-4 shadow-brand">
      {placeholder || !image ? (
        <div className="flex aspect-[16/9] w-full flex-col items-center justify-center gap-2 rounded-xl border border-dashed border-border bg-muted/60">
          <ImageIcon className="h-8 w-8 text-muted-foreground" aria-hidden="true" />
          <span className="text-xs font-semibold uppercase tracking-wider text-muted-foreground">
            Placeholder image
          </span>
        </div>
      ) : (
        <img
          src={image}
          alt={alt ?? ""}
          loading="lazy"
          className="aspect-[16/9] w-full rounded-xl object-cover"
          style={imagePosition ? { objectPosition: imagePosition } : undefined}
        />
      )}
      <figcaption className="px-1 pb-1 pt-4" style={{ fontFamily: "'Poppins', sans-serif" }}>
        <p className="text-3xl font-semibold leading-tight text-[#693D94] md:text-4xl">{stat}</p>
        <p className="mt-2 text-base leading-relaxed text-muted-foreground">{body}</p>
        {source ? (
          <p className="mt-3 text-xs uppercase tracking-wider text-muted-foreground/80">{source}</p>
        ) : null}
      </figcaption>
    </figure>
  );
}
